import React, { useState } from 'react';
import Swal from 'sweetalert2';
import imgExcluir from '../../../../src/assets/icons/delete.png';
import { projectService } from '../../../services/projectService';

const DeleteButton = ({ closeModal, id }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleDelete = async (id) => {
    try {
      const formData = new FormData();
      formData.append('id', id);

      const token = sessionStorage.getItem('Authorization');

      const response = await projectService.deleteProjectCarbonCredit(id, formData, token);
      console.log('✅ Excluído com sucesso! Resposta da API:', response);

      Swal.fire({
        title: 'Sucesso!',
        text: 'Item excluído com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      });

      setIsClicked(!isClicked);
      closeModal();
    } catch (error) {
      console.error('❌ Erro ao excluir item:', error);

      Swal.fire({
        title: 'Erro!',
        text: 'Falha ao executar a operação de exclusão. Por favor, tente novamente mais tarde.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const confirmDelete = (id) => {
    Swal.fire({
      title: 'Confirmação',
      text: 'Tem certeza que deseja excluir?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--danger)',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const buttonStyles = {
    backgroundImage: `url(${imgExcluir})`,
    backgroundSize: 'contain',
    width: '25px',
    height: '25px',
    backgroundColor: isClicked ? 'var(--info)' : 'var(--surface-3)',
    color: isClicked ? 'var(--text-primary)' : 'var(--text-on-accent)',
    border: '2px solid',
    borderRadius: '20px',
    padding: '15px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s, box-shadow 0.3s, transform 0.3s',
    boxShadow: isClicked ? 'none' : 'var(--shadow-sm)',
    transform: isClicked ? 'translate(2px, 2px)' : 'translate(0, 0)',
  };

  // Defina o estilo de cor do texto inicialmente como branco quando a tela é aberta
  if (!isClicked) {
    buttonStyles.color = 'var(--text-primary)';
  }

  return (
    <div style={{ width: '100%', padding: '5px' }}>
      <button
        style={buttonStyles}
        onMouseEnter={(e) => {
          if (!isClicked) {
            e.target.style.transform = 'translate(-2px, -2px)';
            e.target.style.boxShadow = 'var(--shadow-md)';
            e.target.style.backgroundColor = 'var(--warning)';
            e.target.style.border = '2px solid red';
            e.target.style.color = 'var(--text-on-accent)';
          }
        }}
        onMouseDown={(e) => {
          if (!isClicked) {
            e.target.style.backgroundColor = 'var(--accent-soft)';
            e.target.style.boxShadow = 'none';
            e.target.style.transform = 'translate(1px, 1px)';
          }
        }}
        onMouseUp={(e) => {
          if (!isClicked) {
            e.target.style.backgroundColor = 'var(--accent-soft)';
            e.target.style.boxShadow = 'none';
            e.target.style.transform = 'translate(0, 0)';
            confirmDelete(id);
          }
        }}
        onMouseLeave={(e) => {
          if (!isClicked) {
            e.target.style.transform = 'translate(0, 0)';
            e.target.style.boxShadow = 'var(--shadow-sm)';
            e.target.style.backgroundColor = 'var(--surface-3)';
            e.target.style.border = '2px solid white';
            e.target.style.color = 'var(--text-primary)';
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
      </button>
    </div>
  );
};

export default DeleteButton;
